export const BACK_AND_FORTH = 'back-and-forth';
export const IN_THE_ROUND = 'in-the-round';

export const STITCH_PATTERNS: string[] = [BACK_AND_FORTH, IN_THE_ROUND];
